import { PIE_CHART_LABELS_INFO } from '../../../constants';
import * as S from './style';

interface Props {
  onMouseEnter?: (index: number) => void;
  onMouseLeave?: (index: number) => void;
}

export default function Legends({ onMouseEnter, onMouseLeave }: Props) {
  return (
    <S.Wrapper>
      {PIE_CHART_LABELS_INFO.map((obj, index) => (
        <S.Legend
          key={index}
          backgroundColor={obj.backgroundColor}
          onMouseEnter={() => {
            if (onMouseEnter) {
              onMouseEnter(index);
            }
          }}
          onMouseLeave={() => {
            if (onMouseLeave) {
              onMouseLeave(index);
            }
          }}>
          {obj.label}
        </S.Legend>
      ))}
    </S.Wrapper>
  );
}
